import { Node, Edge } from "reactflow";

// ============================================================================
// LAYOUT CONSTANTS
// ============================================================================

export const Layouts = { VERTICAL: "TB" as const, HORIZONTAL: "LR" as const };
export type Layout = typeof Layouts[keyof typeof Layouts];

// ============================================================================
// INITIAL STATE CONSTANTS
// ============================================================================

export const initialNodes: Node[] = [];
export const initialEdges: Edge[] = [];

// ============================================================================
// NODE DIMENSIONS
// ============================================================================

// Node dimensions based on actual component sizes
export const nodeWidth = 240;
export const nodeHeight = 80; // Increased to account for category label and padding

// ============================================================================
// LAYOUT CONFIGURATION
// ============================================================================

export const LAYOUT_CONFIG = {
    HORIZONTAL_SPACING: 250,
    VERTICAL_SPACING: 150,
    MAX_COMPONENTS_PER_ROW: 4,
    INITIAL_X_OFFSET: 100,
    INITIAL_Y_OFFSET: 100,
    DAGRE_NODE_SEPARATION: {
        HORIZONTAL: 80,
        VERTICAL: 50
    },
    DAGRE_RANK_SEPARATION: {
        HORIZONTAL: 80,
        VERTICAL: 50
    },
    DAGRE_MARGINS: {
        X: 50,
        Y: 50
    }
};

// ============================================================================
// STREAM NODE DIMENSIONS
// ============================================================================

export const STREAM_NODE = {
    WIDTH: 32,
    HEIGHT: 32,
    LAYOUT_HEIGHT: 52
};

// ============================================================================
// EDGE STYLING CONSTANTS
// ============================================================================

export const EDGE_COLORS = {
    DEPLOYED: "#30A9EE",
    RUNNING: "#30A9EE",
    DEFAULT: "#BCC9D6",
    HIGHLIGHT: "#089bee"
};

export const EDGE_STYLES = {
    DEFAULT_WIDTH: 2,
    HIGHLIGHT_WIDTH: 3,
    HIGHLIGHT_Z_INDEX: 1
};
